export enum SurveyStatus {
  Clear = 'SurveyStatus.Clear',
  Loss = 'SurveyStatus.Loss',
  Coming = 'SurveyStatus.Coming',
  Incomplete = 'SurveyStatus.Incomplete',
  NoBackgroundData = 'SurveyStatus.NoBackgroundData',
  Archived = 'SurveyStatus.Archived',
  Cancelled = 'SurveyStatus.Cancelled',
}
